import { cn } from '#app/lib/utils'

interface LogoProps {
	className?: string
	size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
	sm: 'w-6 h-6',
	md: 'w-8 h-8',
	lg: 'w-12 h-12',
}

export function Logo({ className, size = 'md' }: LogoProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 160 160"
			className={cn(sizeClasses[size], className)}
		>
			<path d="M55.2 20.5 54 22.3l1.2-1.8Z" />
			<path
				d="M137.5 28.8v59.1c0 3-1 5.9-2.7 8.1l-27.6 42.3-.2.3a13.7 13.7 0 0 1-11.6 6.3H36.3c-7.6 0-13.8-6.2-13.8-13.8V72c0-3.1 1-6 2.8-8.3l27.1-41.5 1.2-1.9C56.1 17.1 60 15 64.5 15h59.1c7.6 0 13.8 6.2 13.8 13.8Z"
				fill="#757bff"
			/>
			<text
				fill="#fff"
				fontFamily="system-ui, -apple-system, sans-serif"
				fontSize="56.4"
				fontWeight="bold"
				transform="translate(56.6 72.2)"
			>
				<tspan x="0" y="0">
					TS
				</tspan>
			</text>
		</svg>
	)
}
